import {
  type MutationState,
  useMutation,
} from 'src/core/api/hooks/useMutation';

export const useDeleteBudgetMutation = (id: string): MutationState => {
  return useMutation({
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: `/budgets/budgets/${id}`,
      method: 'delete',
    },
    options: {
      throwOnError: true,
      onSuccess({ client }): void {
        client.invalidateQueries(['budgetaryExercises']);
      },
    },
  });
};
